import { Form, Button, Row, Col } from "react-bootstrap";
import { useState, useRef, ChangeEvent } from "react";
import { useTranslation } from "react-i18next";

interface LoadDocumentProps {
    setInitialFile: (file: File) => void;
    setIsStepLoadDocument: (isStepLoadDocument: boolean) => void;
    setIsStepReadDocument: (isStepReadDocument: boolean) => void;
    setIsLoadFormWithoutDocument: (isLoadFormWithoutDocument: boolean) => void;
}

export default function LoadDocument({ setInitialFile, setIsStepLoadDocument, setIsStepReadDocument, setIsLoadFormWithoutDocument }: LoadDocumentProps) {
    const [showLoadFileButtons, setShowLoadFileButtons] = useState(true);
    const [preview, setPreview] = useState<string | null>(null);
    const [fileType, setFileType] = useState<string | null>(null);
    const { t } = useTranslation();

    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleOpenModalToSelectFile = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
        const selectedFile = e.target.files?.[0];
        if (!selectedFile)
            return;
        
        setShowLoadFileButtons(false);
        showPreviewFile(selectedFile);
        setIsStepLoadDocument(true);
    };

    const showPreviewFile =  (filePreview: File) => {
        const reader = new FileReader();
        if (filePreview.type.startsWith('image/')) {
            reader.onloadend = () => {
                setPreview(reader.result as string);
                setFileType('image');
            };
            reader.readAsDataURL(filePreview);
        } else if (filePreview.type.startsWith('text/')) {
            reader.onloadend = () => {
                setPreview(reader.result as string);
                setFileType('text');
            };
            reader.readAsText(filePreview);
        } else if (filePreview.type === 'application/pdf') {
            reader.onloadend = () => {
                setPreview(reader.result as string); // base64
                setFileType('pdf');
            };
            reader.readAsDataURL(filePreview);
        } else {
            setPreview(null);
            setFileType('unsupported');
        }

        setInitialFile(filePreview);
    };

    const hadleContinueWithoutFile = async () => {
        setShowLoadFileButtons(false);
        setIsStepLoadDocument(true);
        setIsStepReadDocument(true);
        setIsLoadFormWithoutDocument(true);
    }

    return (<>
        <div>
            {fileType === 'image' && preview && (
                <div>
                    <img src={preview} alt="preview" style={{ maxWidth: '300px' }} />
                </div>
            )}

            {fileType === 'text' && preview && (
                <div>
                    <pre>{preview}</pre>
                </div>
            )}

            {fileType === 'pdf' && preview && (
                <div>
                    <iframe
                        src={preview}
                        title="PDF Preview"
                        width="100%"
                        height="500px"
                        style={{ border: '1px solid #ccc' }}
                    />
                </div>
            )}

            {fileType === 'unsupported' && (
                <p>{t("claim:newClaimFileUnsupported")}</p>
            )}
        </div >
        {showLoadFileButtons &&
            <div className="d-flex flex-column justify-content-center align-items-center" style={{ height: '100%', width: '100%', position: "absolute" }}>

                <i className="bi bi-arrow-up-circle" style={{ fontSize: '100px' }} ></i>
                <Row>
                    <Col md={6}>
                        <Button variant="secondary" onClick={hadleContinueWithoutFile} style={{ width: "200px" }} >
                            {t("claim:withoutAttachedFileButton")}
                        </Button>
                    </Col>
                    <Col md={6}>
                        <Button variant="primary" onClick={handleOpenModalToSelectFile} style={{ width: "200px" }} >
                            {t("claim:loadDocumentButton")}
                        </Button>
                    </Col>
                 </Row>
                <Form.Control
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: 'none' }}
                />
            </div>
        }
        </>
    );
}

